export const LOAN_APPLICATION_DETAIL_TAB = {
  APPLICATION_DETAILS: 'application_details',
  KYC_DETAILS: 'kyc_details',
  CB_DETAILS: 'cb_details',
  LOAN: 'loan',
  DOCUMENTS: 'documents',
  AGREEMENT: 'agreement',
  GUARANTORS: 'guarantors',
  DISBURSEMENT: 'disbursement',
  COMPLETION: 'completion',
  REPAYMENT: 'repayment',
  COLLATERAL: 'collateral',
  INSURANCE: 'insurance',
  VERIFICATION: 'verification',
  HISTORY: 'history',
  AUDIT: 'audit',
  TIMELINE: 'timeline',
};

export const LOAN_APPLICATION_DETAIL_TAB_OPTIONS = [
  { key: LOAN_APPLICATION_DETAIL_TAB.APPLICATION_DETAILS, label: 'Application Details' },
  { key: LOAN_APPLICATION_DETAIL_TAB.KYC_DETAILS, label: 'KYC Details' },
  { key: LOAN_APPLICATION_DETAIL_TAB.CB_DETAILS, label: 'CB Details' },
  { key: LOAN_APPLICATION_DETAIL_TAB.LOAN, label: 'LOAN' },
  { key: LOAN_APPLICATION_DETAIL_TAB.DOCUMENTS, label: 'Documents' },
  { key: LOAN_APPLICATION_DETAIL_TAB.AGREEMENT, label: 'Agreement' },
  { key: LOAN_APPLICATION_DETAIL_TAB.GUARANTORS, label: 'Gurantors' },
  { key: LOAN_APPLICATION_DETAIL_TAB.DISBURSEMENT, label: 'Disbursement' },
  { key: LOAN_APPLICATION_DETAIL_TAB.COMPLETION, label: 'Completion' },
  { key: LOAN_APPLICATION_DETAIL_TAB.REPAYMENT, label: 'Repayment' },
  { key: LOAN_APPLICATION_DETAIL_TAB.COLLATERAL, label: 'Collateral' },
  { key: LOAN_APPLICATION_DETAIL_TAB.INSURANCE, label: 'Insurance' },
  { key: LOAN_APPLICATION_DETAIL_TAB.VERIFICATION, label: 'Verification' },
  { key: LOAN_APPLICATION_DETAIL_TAB.HISTORY, label: 'History' },
  { key: LOAN_APPLICATION_DETAIL_TAB.AUDIT, label: 'Audit' },
  { key: LOAN_APPLICATION_DETAIL_TAB.TIMELINE, label: 'Timeline' },
];

export const LOAN_APPLICATION_MILESTONE_STATUS = {
  COMPLETE: 'complete',
  SLOW: 'slow',
  DELAYED: 'delayed',
  IN_PROGRESS: 'in_progress',
  NOT_STARTED: 'not_started',
};

export const LOAN_APPLICATION_MILESTONE_STATUS_LABEL = {
  [LOAN_APPLICATION_MILESTONE_STATUS.COMPLETE]: 'Completed on time',
  [LOAN_APPLICATION_MILESTONE_STATUS.SLOW]: 'Completed with delay',
  [LOAN_APPLICATION_MILESTONE_STATUS.DELAYED]: 'SLA breached',
  [LOAN_APPLICATION_MILESTONE_STATUS.IN_PROGRESS]: 'In progress',
  [LOAN_APPLICATION_MILESTONE_STATUS.NOT_STARTED]: 'Not started',
};

export const LOAN_APPLICATION_STAGE_UPDATE_SLA_HOURS = {
  LOAN_APPL_STARTED: 0,
  CUSTOMER_KYC: 24,
  DOC_VERIFICATION: 6,
  BureauCheck: 4,
  Loan_Offer: 24,
  Loan_Agreement: 24,
  eNACH: 4,
  DISBURSEMENT: 48,
};

export const LOAN_APPLICATION_KYC_FIELD_TYPE = {
  TEXT: 'text',
  DATE: 'date',
  GENDER: 'gender',
};

export const LOAN_APPLICATION_KYC_MATCH_TONE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  NEUTRAL: 'neutral',
};

export const LOAN_APPLICATION_KYC_CELL_TONE = {
  BEST: 'best',
  GOOD: 'good',
  BAD: 'bad',
};

export const LOAN_APPLICATION_KYC_MATCH_LEGEND = [
  { id: LOAN_APPLICATION_KYC_CELL_TONE.GOOD, label: 'Good' },
  { id: LOAN_APPLICATION_KYC_CELL_TONE.BEST, label: 'Best' },
  { id: LOAN_APPLICATION_KYC_CELL_TONE.BAD, label: 'Bad' },
];

export const LOAN_APPLICATION_KYC_BUREAU_SOURCE = {
  API: 'api',
  OCR: 'ocr',
};

export const LOAN_APPLICATION_KYC_BUREAU_SOURCE_LABEL = {
  [LOAN_APPLICATION_KYC_BUREAU_SOURCE.API]: 'API',
  [LOAN_APPLICATION_KYC_BUREAU_SOURCE.OCR]: 'OCR',
};

export const LOAN_APPLICATION_KYC_EMPTY_VALUES = ['na', 'n/a', 'null', 'none', 'undefined', '-'];

export const LOAN_APPLICATION_KYC_PAN_FIELDS = [
  { key: 'name', label: 'Name', type: LOAN_APPLICATION_KYC_FIELD_TYPE.TEXT, allowPartial: true },
  { key: 'dob', label: 'Date of birth', summaryLabel: 'DOB', type: LOAN_APPLICATION_KYC_FIELD_TYPE.DATE },
  { key: 'pan_number', label: 'PAN number', type: LOAN_APPLICATION_KYC_FIELD_TYPE.TEXT },
];

export const LOAN_APPLICATION_KYC_AADHAAR_FIELDS = [
  { key: 'name', label: 'Name', type: LOAN_APPLICATION_KYC_FIELD_TYPE.TEXT, allowPartial: true },
  { key: 'dob', label: 'Date of birth', summaryLabel: 'DOB', type: LOAN_APPLICATION_KYC_FIELD_TYPE.DATE },
  { key: 'aadhaar_number', label: 'Aadhaar number', type: LOAN_APPLICATION_KYC_FIELD_TYPE.TEXT },
  { key: 'gender', label: 'Gender', type: LOAN_APPLICATION_KYC_FIELD_TYPE.GENDER },
  { key: 'address', label: 'Address', type: LOAN_APPLICATION_KYC_FIELD_TYPE.TEXT, longText: true },
];

export const LOAN_APPLICATION_KYC_MATCH_FIELDS = [
  { key: 'name_matching_pct', label: 'Name match' },
  { key: 'dob_matching', label: 'DOB match' },
];

export const LOAN_APPLICATION_KYC_CAPTURED_IMAGE_FIELDS = [
  { key: 'captured_image_url', label: 'Captured selfie' },
  { key: 'emprint_url', label: 'Fingerprint' },
];

export const LOAN_APPLICATION_KYC_SUMMARY_PHOTO_ROWS = [
  { key: 'user_photo', label: 'User Photo' },
  { key: 'id_photo', label: 'ID Doc Photo' },
];

export const LOAN_APPLICATION_KYC_PAN_SUMMARY = {
  id: 'pan',
  title: 'PAN Matching Summary',
  subtitle: 'Review the matching status of your PAN information',
  documentLabel: 'PAN Card',
  fields: LOAN_APPLICATION_KYC_PAN_FIELDS,
  apiUserPhotoKey: null,
  apiIdPhotoKey: 'pan_photo',
  userPhotoKey: 'photo',
};

export const LOAN_APPLICATION_KYC_AADHAAR_SUMMARY = {
  id: 'aadhaar',
  title: 'Aadhaar Matching Summary',
  subtitle: 'Review the matching status of your Aadhaar information',
  documentLabel: 'Aadhaar Card',
  fields: LOAN_APPLICATION_KYC_AADHAAR_FIELDS,
  apiUserPhotoKey: 'profile_image',
  apiIdPhotoKey: 'aadhaar_photo',
  userPhotoKey: 'photo',
};

export const LOAN_APPLICATION_CIBIL_SCORE_MIN = 300;
export const LOAN_APPLICATION_CIBIL_SCORE_MAX = 900;
export const LOAN_APPLICATION_CIBIL_SCAN_PERIOD_MS = 1800;
export const LOAN_APPLICATION_CIBIL_SETTLE_DURATION_MS = 700;

export const LOAN_APPLICATION_CIBIL_BAND = {
  POOR: 'poor',
  FAIR: 'fair',
  GOOD: 'good',
  EXCELLENT: 'excellent',
};

export const LOAN_APPLICATION_CIBIL_BANDS = [
  { id: LOAN_APPLICATION_CIBIL_BAND.POOR, min: 300, max: 549, label: 'Poor' },
  { id: LOAN_APPLICATION_CIBIL_BAND.FAIR, min: 550, max: 649, label: 'Fair' },
  { id: LOAN_APPLICATION_CIBIL_BAND.GOOD, min: 650, max: 749, label: 'Good' },
  { id: LOAN_APPLICATION_CIBIL_BAND.EXCELLENT, min: 750, max: 900, label: 'Excellent' },
];

export const LOAN_APPLICATION_CIBIL_BAND_COLORS = {
  [LOAN_APPLICATION_CIBIL_BAND.POOR]: '#d42215',
  [LOAN_APPLICATION_CIBIL_BAND.FAIR]: '#f7941e',
  [LOAN_APPLICATION_CIBIL_BAND.GOOD]: '#0c4e8d',
  [LOAN_APPLICATION_CIBIL_BAND.EXCELLENT]: '#16a34a',
};

export const LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE = {
  AMOUNT: 'amount',
  PERCENT: 'percent',
  DATE: 'date',
  TENURE: 'tenure',
  NUMBER: 'number',
  TEXT: 'text',
};

export const LOAN_APPLICATION_LOAN_KPI_FIELDS = [
  { key: 'requested_amount', label: 'Requested amount', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
  { key: 'disbursement_amount', label: 'Disbursement amount', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
  { key: 'montly_epi', label: 'Monthly EPI', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
  { key: 'total_payable_amount', label: 'Total payable', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
];

export const LOAN_APPLICATION_LOAN_META_FIELDS = [
  { key: 'application_id', label: 'Application ID', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.TEXT },
  { key: 'roi', label: 'Rate of interest', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.PERCENT },
  { key: 'requested_tenure', label: 'Tenure', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.TENURE },
  { key: 'total_epis', label: 'Total EPIs', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.NUMBER },
  { key: 'processing_fee', label: 'Processing fee', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
  { key: 'insurance_amount', label: 'Insurance', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
  { key: 'epi_start_date', label: 'EPI start', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.DATE },
  { key: 'epi_end_date', label: 'EPI end', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.DATE },
  { key: 'disbursement_status', label: 'Disbursement status', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.TEXT },
];

export const LOAN_APPLICATION_EPI_SCHEDULE_COLUMNS = [
  { key: 'installment', label: '#', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.NUMBER },
  { key: 'epi_date', label: 'Due date', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.DATE },
  { key: 'epi_amount', label: 'EPI', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
  { key: 'principle_amount', label: 'Principal', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
  { key: 'interest_amount', label: 'Interest', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
  { key: 'outstanding_amount', label: 'Outstanding', type: LOAN_APPLICATION_LOAN_SUMMARY_FIELD_TYPE.AMOUNT },
];

export const LOAN_APPLICATION_STAGES_STATUS_TYPE_ID = 'LOAN_APPL_STAGES';

export const LOAN_APPLICATION_STATUS_STATUS_TYPE_ID = 'LOAN_APPL_STATUS';

/** sessionStorage key prefix for list→detail application row handoff. */
export const LOAN_APPLICATION_LIST_RECORD_STORAGE_PREFIX = 'loan_application_list_record:';

export const LOAN_APPLICATION_PARTY_TYPE = {
  PERSON: 'PERSON',
  PARTY_GROUP: 'PARTY_GROUP',
};

export const LOAN_APPLICATION_ROLES_PAGE_SIZE = 100;

export const LOAN_APPLICATION_MOVEMENT_PAGE_SIZE = 100;

export const LOAN_APPLICATION_MOVEMENT_MAX_PAGES = 50;

export const LOAN_APPLICATION_PARTY_CARD_TITLE = {
  MAIN_APPLICANT: 'Main Applicant',
  ASSOCIATED_PARTY: 'Associated Party',
  PARTY: 'Party',
};

export const LOAN_APPLICATION_PARTY_CARD_FIELD = {
  NAME: { key: 'name', label: 'Name' },
  AGE: { key: 'age', label: 'Age' },
  GENDER: { key: 'gender', label: 'Gender' },
  BIRTH_DATE: { key: 'birth_date', label: 'Date of Birth' },
  ROLE: { key: 'role', label: 'Role' },
  PARTY_ID: { key: 'party_id', label: 'Party ID' },
  COMMENTS: { key: 'comments', label: 'Comments' },
};

export const LOAN_APPLICATION_PARTY_CONTACT_FIELD = {
  MOBILE: { keyPrefix: 'telecom', fallbackLabel: 'Mobile' },
  EMAIL: { keyPrefix: 'email', fallbackLabel: 'Email' },
  POSTAL: { keyPrefix: 'postal', fallbackLabel: 'Postal Address' },
  IDENTIFICATION: { keyPrefix: 'identification', fallbackLabel: 'Identification' },
};

export const LOAN_APPLICATION_FILTER_STATUS_PAGE_SIZE = 25;

export const LOAN_APPLICATION_FILTER_PRODUCT_PAGE_SIZE = 50;

export const LOAN_APPLICATION_LIST_FILTERS_EMPTY = {
  application_id: '',
  application_stage: undefined,
  application_status: undefined,
  mobile: '',
  product_id: undefined,
};

/** Sample attachment URLs used when API has not yet sent attachment_url. */
export const LOAN_APPLICATION_SAMPLE_PDF_URL = 'https://pdfobject.com/pdf/sample.pdf';

export const LOAN_APPLICATION_SAMPLE_IMAGE_URL =
  'https://fastly.picsum.photos/id/398/536/354.jpg?hmac=3QyV-PACx18kZX7AqRy4b9jJuXs67SIYPsGkpYVFGqc';

export const LOAN_APPLICATION_ATTACHMENT_KIND = {
  PDF: 'pdf',
  IMAGE: 'image',
  VIDEO: 'video',
  UNKNOWN: 'unknown',
};

export const LOAN_APPLICATION_DOCUMENT_TYPES = [
  { key: 'PAN_UPLOAD', label: 'PAN' },
  { key: 'AADHAAR_FRONT_SIDE', label: 'Aadhaar front' },
  { key: 'AADHAAR_BACK_SIDE', label: 'Aadhaar back' },
  { key: 'BANL_STMT_UPLOAD', label: 'Bank statement' },
  { key: 'ADH_FSIDE_EMPRINT', label: 'Aadhaar front fingerprint' },
  { key: 'ADH_BSIDE_EMPRINT', label: 'Aadhaar back fingerprint' },
  { key: 'PAN_EMPRINT', label: 'PAN fingerprint' },
];

export const LOAN_APPLICATION_DOCUMENT_CONTAIN_KEYS = [
  'ADH_FSIDE_EMPRINT',
  'ADH_BSIDE_EMPRINT',
  'PAN_EMPRINT',
];

export const LOAN_APPLICATION_AGREEMENT_BANK_FIELDS = [
  { key: 'account_holder_name', label: 'Account holder' },
  { key: 'bank_account_number', label: 'Account number' },
  { key: 'bank_name', label: 'Bank name' },
  { key: 'ifsc_code', label: 'IFSC' },
  { key: 'bank_reference_number', label: 'Bank reference' },
  { key: 'bank_validation_txn_id', label: 'Transaction ID' },
];

export const LOAN_APPLICATION_UPDATE_STATUS_OPTIONS = [
  { value: LOAN_APPLICATION_MILESTONE_STATUS.NOT_STARTED, label: 'Not started' },
  { value: 'in_progress', label: 'In progress' },
  { value: LOAN_APPLICATION_MILESTONE_STATUS.COMPLETE, label: 'Completed on time' },
  { value: LOAN_APPLICATION_MILESTONE_STATUS.SLOW, label: 'Completed with delay' },
  { value: LOAN_APPLICATION_MILESTONE_STATUS.DELAYED, label: 'SLA breached' },
  { value: 'on_hold', label: 'On hold' },
  { value: 'rejected', label: 'Rejected' },
];

export const LOAN_APPLICATION_ANALYTICS_MOCK = {
  totalLoanAmountLabel: 'Rs. 103.62 Cr',
  growthPercent: '16.6%',
  stageSegments: [
    { label: 'Underwriting', value: 48, color: '#F472B6' },
    { label: 'Sanction', value: 28, color: '#FBBF24' },
    { label: 'Disbursed', value: 24, color: '#60A5FA' },
  ],
  productSegments: [
    { label: 'Personal Loan', value: 42, color: '#F472B6' },
    { label: 'Home Loan', value: 33, color: '#FBBF24' },
    { label: 'Business Loan', value: 25, color: '#60A5FA' },
  ],
  assignSegments: [
    { label: 'Assigned', value: 55, color: '#F472B6' },
    { label: 'Unassigned', value: 25, color: '#FBBF24' },
    { label: 'Reassigned', value: 20, color: '#60A5FA' },
  ],
};

export const LOAN_APPLICATION_LIST_ACTION = {
  VIEW: 'view',
  DOWNLOAD_CAM: 'download_cam',
};

export const LOAN_APPLICATION_LIST_ACTION_LABEL = {
  [LOAN_APPLICATION_LIST_ACTION.VIEW]: 'View application',
  [LOAN_APPLICATION_LIST_ACTION.DOWNLOAD_CAM]: 'CAM download',
};

export const LOAN_APPLICATION_SIDE_ACTION = {
  UPDATE_APPLICATION: 'update_application',
  ADD_NOTES: 'add_notes',
  REJECT_LOAN: 'reject_loan',
  CREDIT_UW: 'credit_uw',
  NOTES: 'notes',
};

export const LOAN_APPLICATION_SIDE_ACTION_TONE = {
  [LOAN_APPLICATION_SIDE_ACTION.UPDATE_APPLICATION]: 'update',
  [LOAN_APPLICATION_SIDE_ACTION.ADD_NOTES]: 'add',
  [LOAN_APPLICATION_SIDE_ACTION.REJECT_LOAN]: 'reject',
  [LOAN_APPLICATION_SIDE_ACTION.CREDIT_UW]: 'credit',
  [LOAN_APPLICATION_SIDE_ACTION.NOTES]: 'notes',
};

export const LOAN_APPLICATION_SIDE_ACTION_OPTIONS = [
  {
    key: LOAN_APPLICATION_SIDE_ACTION.UPDATE_APPLICATION,
    label: 'Update Application',
  },
  {
    key: LOAN_APPLICATION_SIDE_ACTION.ADD_NOTES,
    label: 'Add Notes',
  },
  {
    key: LOAN_APPLICATION_SIDE_ACTION.REJECT_LOAN,
    label: 'Reject Loan',
  },
  {
    key: LOAN_APPLICATION_SIDE_ACTION.CREDIT_UW,
    label: 'Credit U/W',
  },
  {
    key: LOAN_APPLICATION_SIDE_ACTION.NOTES,
    label: 'Notes',
  },
];
